import React from 'react';
import createReactClass from 'create-react-class';
import moment from 'moment';
import ProgressMeter from './ProgressMeter';
import StorageLocation from './StorageLocation';

const $ = window.$;

const $chrt_border_color = '#efefef';
const $chrt_second = '#6595b4';
//const $chrt_fourth = '#7e9d3a';

const colorPalette = ['#e69373', '#805240', '#bf5830',
             '#77d36a', '#488040', '#43bf30' ,
             '#557aaa', '#405c80', '#cfd9e6', '#306ebf'];

var CurrentStatusWidget = createReactClass({
  getDefaultProps(){
    return {
      stockvalue: {
        storageLocations: [],
        entries: [],
        totalStockValue: 0
      },
      purchases: {
        months: []
      }
    };
  },

  componentDidUpdate() {
    this._updateCharts();
  },

  _updateCharts() {
    // timeout is needed or the bars in the bars chart overlap
    setTimeout(() => {
      runAllCharts(); //eslint-disable-line no-undef
      this._initializeStockValueChart();
      this._initializeOrdersChart();
    }, 200);
  },

  _initializeStockValueChart() {
    if ($('#stockvalue-chart').length) {

      var d = this.props.stockvalue.entries.map(x => [moment(x.date).valueOf(), x.value]);

      if(d.length > 0) {
        // add an entry for today
        d.push([moment().valueOf(), d[d.length-1][1]]);
      }

      var options = {
        xaxis : {
          mode : 'time',
          tickLength : 5
        },
        series : {
          lines : {
            show : true,
            lineWidth : 1,
            fill : true,
            fillColor : {
              colors : [{
                opacity : 0.1
              }, {
                opacity : 0.15
              }]
            }
          },
                    //points: { show: true },
          shadowSize : 0
        },
        selection : {
          mode : 'x'
        },
        grid : {
          hoverable : true,
          clickable : true,
          tickColor : $chrt_border_color,
          borderWidth : 0,
          borderColor : $chrt_border_color,
        },
        tooltip : true,
        tooltipOpts : {
          content : '€%y.2',
          shifts: {
            x: -20,
            y: 20
          },
          dateFormat : '%y-%0m-%0d',
          defaultTheme : false
        },
        colors : [$chrt_second],

      };

      $.plot($('#stockvalue-chart'), [d], options);
    }
  },


  _initializeOrdersChart() {
    if ($('#orders-chart').length === 0) return;

    const months = this.props.purchases.months;
    if(months.length === 0) return;

    let order = 1;
    var addData = (months, label, getValue) => {
      var data = months.map(month => [moment(month.date).valueOf(), getValue(month)]);
      return {
        data : data,
        label: label,
        bars: {
          order: order++
        }
      };
    };

    var ds = [
      addData(months, 'Bestellvorschläge neu', month => month.suggestionsAdded),
      addData(months, 'Bestellvorschläge abgelehnt', month => month.suggestionsRejected),
      addData(months, 'Bestellvorschläge genehmigt', month => month.suggestionsConfirmed),
      addData(months, 'Bestellungen neu', month => month.ordersAdded),
      addData(months, 'Bestellungen abgelehnt', month => month.ordersRejected),
      addData(months, 'Bestellungen bestellt', month => month.ordersOrdered),
      addData(months, 'Bestellungen abgeschlossen', month => month.ordersClosed)
    ];

    const dateTo = moment().startOf('month').add(1, 'month').valueOf();
    const dateFrom = moment().startOf('month').add(-1, 'year').valueOf();

          //Display graph
    $.plot($('#orders-chart'), ds, {
      //colors : [$chrt_second, $chrt_fourth, '#666', '#BBB'],
      series: {
        shadowSize: 1,
        bars: {
          show: true,
          barWidth: (30 * 24 * 60 * 60 * 1000) / ds.length / 2,
          fill: true
        }
      },
      grid : {
        show : true,
        hoverable : true,
        clickable : true,
        tickColor : $chrt_border_color,
        borderWidth : 0,
        borderColor : $chrt_border_color,
      },
      legend : {
        show: true,
        noColumns: 2,
        labelBoxBorderColor: '#000000',
        container: $('#legend-container'),
      },
      tooltip : true,
      tooltipOpts : {
        content : '<b>%s</b> = <span>%y</span>',
        defaultTheme : false
      },
      valueLabels: {
        show: true
      },
      multiplebars: true,
      xaxis: {
        mode: 'time',
        minTickSize: [1, 'month'],
        min: dateFrom,
        max: dateTo,
        timeformat: '%m/%Y'
      },
      yaxis: {
        minTickSize: 1
      },
    });
  },

  render() {
    const storageLocations = this.props.stockvalue.storageLocations.map((x, index) => (
        <StorageLocation key={x.id} totalStockValue={this.props.stockvalue.totalStockValue} storageLocation={x} color={colorPalette[index % colorPalette.length]} />
      ));

    var getSum = (months, getValue) => {
      var sum = months.reduce((prevValue, month) => prevValue + getValue(month), 0);
      return sum;
    };

    const suggestionsTotal = getSum(this.props.purchases.months, month =>
      month.suggestionsRejected +
      month.suggestionsConfirmed +
      month.suggestionsConfirmationByMayorNeeded);

    const suggestionsRejected = getSum(this.props.purchases.months, month => month.suggestionsRejected);
    const suggestionsConfirmed = getSum(this.props.purchases.months, month => month.suggestionsConfirmed);

    return (
      <article className="col-sm-12">
          <div className="jarviswidget" id="wid-id-0" data-widget-togglebutton="false" data-widget-editbutton="false" data-widget-fullscreenbutton="false" data-widget-colorbutton="false" data-widget-deletebutton="false">
              <header>
                  <span className="widget-icon"> <i className="glyphicon glyphicon-stats txt-color-darken"></i> </span>
                  <h2>Aktueller Status </h2>

                  <ul className="nav nav-tabs pull-right in" id="myTab">
                      <li className="active" onClick={() => this._updateCharts()}>
                          <a data-toggle="tab" href="#s1"><i className="fa fa-euro"></i> <span className="hidden-mobile hidden-tablet">Lagerwert</span></a>
                      </li>

                      <li onClick={() => this._updateCharts()}>
                          <a data-toggle="tab" href="#s3"><i className="fa fa-clock-o"></i> <span className="hidden-mobile hidden-tablet">Bestellungen</span></a>
                      </li>
                  </ul>

              </header>

              <div className="no-padding">
                  <div className="jarviswidget-editbox"></div>

                  <div className="widget-body">
                      <div id="myTabContent" className="tab-content">

                          {/* Lagerwert Tab */}
                          <div className="tab-pane fade active in padding-10 no-padding-bottom" id="s1">
                              <div className="row no-space">
                                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                                      <span className="demo-liveupdate-1">
                                          <span className="onoffswitch-title">Lagerwert gesamt über das letzte Jahr [€]</span>
                                      </span>

                                      <div id="stockvalue-chart" className="chart-large txt-color-blue"></div>

                                  </div>
                              </div>

                              <div className="show-stat-microcharts" style={{marginTop: 10}}>
                                {storageLocations}
                              </div>

                          </div>


                          {/* Bestellungen Tab */}
                          <div className="tab-pane fade in padding-10 no-padding-bottom" id="s3">
                              <div className="row no-space">
                                  <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9">

                                      <span className="demo-liveupdate-1">
                                          <span className="onoffswitch-title">Bestellungen über das letzte Jahr</span>
                                      </span>

                                      <div id="orders-chart" className="chart-large has-legend-unique" style={{padding: '20px!important'}}></div>

                                  </div>

                                  <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 show-stats">

                                      <div className="row">
                                          <ProgressMeter title="Genehmigte Bestellvorschläge" count={suggestionsConfirmed} total={suggestionsTotal} color="#71843f" />
                                          <ProgressMeter title="Abgelehnte Bestellvorschläge" count={suggestionsRejected} total={suggestionsTotal} color="#a90329" />

                                          <div id="legend-container" style={{marginTop: 100}}></div>
                                            {/*<span className="show-stat-buttons">
                                              <span className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                  <a className="btn btn-default btn-block hidden-xs">PDF erstellen</a>
                                              </span>
                                          </span>*/}
                                      </div>

                                  </div>
                              </div>

                              <div className="show-stat-microcharts" style={{marginTop: 10}}>
                                {storageLocations}
                              </div>

                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </article>

    );
  }
});

export default CurrentStatusWidget;



// WEBPACK FOOTER //
// ./src/components/dashboard/CurrentStatusWidget.js